import {zoom as zoomView} from "../operations/zoom";

export function zoom(value){
	zoomView(this, value);
}